import React from 'react';

import FormItemEditorRender from './FormItemEditorRender';
import RecordsActions from '../../actions/RecordsActions';
import FormItemUtil from '../../utils/FormItemUtil';
import StringUtil from '../../utils/StringUtil';
import CommonUtil from '../../utils/CommonUtil';
import FormItemConst from '../FormItemConst';
import {KeyDownHelperStore} from '../../stores/UtilStores';
import {DsAllowEditStore}  from '../../stores/CmdTypeStore';

import {SelectAllRecordsStore,SelectRecordsStore2,ReverseSelectRecordsStore} from '../../stores/CommandStore';
require('../../styles/FormItemBoolean.css');


export default class FormItemBooleanRender extends FormItemEditorRender
{
	constructor(props) {
		super(props);

		if(this.props.isSelectedRecords)
		{
			this.unsubscribeSelectAllRecordsStore = 
				  SelectAllRecordsStore.listen(this.onSelectAllRecords.bind(this));
				  
			this.unsubscribeSelectRecordsStore2 = 
				  SelectRecordsStore2.listen(this.onSelectRecords2.bind(this));

			this.unsubscribeReverseSelectRecordsStore = 
				  ReverseSelectRecordsStore.listen(this.onReverseSelectRecords.bind(this));
		}

		this.unsubscribeUtilStores = KeyDownHelperStore.listen(this.onKeyDownHandler.bind(this));
		this.unsubscribeDsAllowEditStore = DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
		//Q21096256this.unsubscirbeGroupCurrentRecordChangedNotGridUserOpStore = GroupCurrentRecordChangedNotGridUserOpStore.listen(this.test.bind(this));
	}

	test(groupAlias)
	{
		if(groupAlias == this.props.groupAlias)
		{
			this.forceUpdate();
		}
	}

	onReverseSelectRecords(groupAlias)
	{
		if(groupAlias == this.props.groupAlias)
		{
			this.onlyUpdateUIChecked = true;

			this.componentDidUpdate();
		}
	}

	onSelectRecords2(value,groupAlias,moduleInstanceId,records)
	{
		if(groupAlias == this.props.groupAlias)
		{
			if(records.indexOf(this.props.rowData) == -1)
				return;
			this.onlyUpdateUIChecked = true;
			if(value)$(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");	
		}
	}

	onSelectAllRecords(value,groupAlias,moduleInstanceId)
	{
		if(groupAlias == this.props.groupAlias)
		{
			this.onlyUpdateUIChecked = true;
			if(value)$(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");	
		}
	}

	onDsAllowEditStore(groupAlias)
	{
		if(this.props.groupAlias == groupAlias)
		{
			this.forceUpdate();
			//let finalValue = this.props.control.getProperty_AllowEdit_Final();

			//this.doSetEnable(finalValue);	
		}
		
	}

	componentWillUnmount()
	{
		super.componentWillUnmount();
		if(this.props.isSelectedRecords)
		{
			this.unsubscribeSelectAllRecordsStore();
		}
		this.unsubscribeUtilStores();
	}

	restoreValue(oldValue)
	{
		let boolvalue = false;
		if(typeof(oldValue) == "boolean")
			boolvalue = oldValue;
		else if(oldValue == "true" || oldValue == "1")
			boolvalue = true;
		this.stopChangedOnce = true;
		this.props.rowData[this.props.dataField] = boolvalue;
		let _this = this;
		setTimeout(function(e){
			if(boolvalue)$(_this.inputField).iCheck("check");else $(_this.inputField).iCheck("uncheck");
		},500)
		
	}

	checkChangeHandler(value)
	{
		if(this.stopChangedOnce == true)
		{
			this.stopChangedOnce = false;
			return;
		}
		//alert(JSON.stringify(this.props.rowData));
		
		//alert("changed");
		let changed = false;
		if(this.props.dataField != undefined && this.props.dataField != null)
		{
			var checked = value;
			var origChecked = this.props.rowData[this.props.dataField];
			if(checked != origChecked)
				changed = true;
			/*if(this.props.rowData != this.props.group.currentRecord)
			{

			}*/
			//alert("checkbox赋值");
			//存在直接点击DataGrid中的booleanRender换行的情况 如果使用onClick 则先更改 再换行触发当前记录变化
			//这会造成currentRecordBak未更改从而再换行时没有自动保存 而使用onChange事件 则先换行 再执行更改
			//感觉自动保存等需求会使得程序存在很大风险 
			this.props.rowData[this.props.dataField] = checked;
		}

	    if(changed)
	    {
	    	RecordsActions.RecordFieldChanged(this.props.rowData,this.props.dataField,origChecked,checked,this);
	    	if(this.props.control)
	    	{
	    		let result = this.props.control.doFieldModifiedRemote(this.props.column.key,checked,origChecked,this.props.rowData,this);
	    		if(!result)
	    		{
	    			return {};
	    		}
	    	}
	    }

	    //alert("dataField changed");
		this.stopPropagation();
		//console.log(this.props.rowData);
	}

	onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	{
		if(record == this.props.rowData)
		{
			//alert(this.props.dataField + "   " + dataField);
			if(this.props.dataField == dataField)
			{
				//let boolvalue = (newValue == "true" || newValue || newValue == "1");
				//if(boolvalue)$(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");
				this.forceUpdate();
			}
		}
	}
	//TODO先去掉 当时为什么加上原因未知
	stopPropagation(e) {
	  return;
	  e = e || window.event;
	  if (e.stopPropagation) { //W3C阻止冒泡方法  
	    e.stopPropagation();
	  } else {
	    e.cancelBubble = true; //IE阻止冒泡方法  
	  }
	}

	checkboxDiveClick(e)
	{
		//if(e && !$(e.target).hasClass("gongqi_render_select"))
		//Q21096256this.clickOnDisable = true;//记录在不可用的情况下被点击 随后将由于本次点击触发render方法
			return;
		let checkboxTemp;
		let x = this.inputField.checked;
		if(x == false){
			checkboxTemp = true;
		}else{
			checkboxTemp = false;
		}
	
		if(checkboxTemp == true){
			this.checkChangeHandler(true,2);
		}else{
			this.checkChangeHandler(false,2);
		}
	}

	componentDidMount()
	{
		super.componentDidMount();
		$(this.inputField).iCheck({
		  checkboxClass: this.props.big?'icheckbox_minimal-blue28':'icheckbox_minimal-blue14',
		  downFocus: true
	    });

	    let _value = this.props.value;
		//let boolvalue = (_value == "true" || _value || _value == "1");
		let boolvalue = false;
		if(typeof(_value) == "boolean")
			boolvalue = _value;
		else if(_value == "true" || _value == "1")
			boolvalue = true;
		if(boolvalue)$(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");
		$(this.inputField).on('ifChecked',this.checkChangeHandler.bind(this,true));
		$(this.inputField).on('ifUnchecked',this.checkChangeHandler.bind(this,false)); 

	
	}

	componentDidUpdate()
	{	
		let _value = this.props.rowData[this.props.dataField];
		//let boolvalue = (_value == "true" || _value || _value == "1");
		let boolvalue = false;
		if(typeof(_value) == "boolean")
			boolvalue = _value;
		else if(_value == "true" || _value == "1")
			boolvalue = true;
		if(boolvalue)$(this.inputField).iCheck("check");else $(this.inputField).iCheck("uncheck");	

		
		/*Q21096256if(this.renderAllowEdit == true)
		{
			if(this.disableToAllowEdit == true)
			{
				this.disableToAllowEdit = false;
				if(boolvalue)$(this.inputField).iCheck("uncheck");else $(this.inputField).iCheck("check");	
			}

			$(this.componentLabel).find(this.props.big?'.icheckbox_minimal-blue28':'.icheckbox_minimal-blue14').removeClass("disabled");
		}*/
	}

	onKeyDownHandler(e,arg)
	{
		if(!e)
			return;
		if(e.keyCode != 32)
			return;
		if($(this.inputField).attr("disabled")=="disabled")
			return;
		if($(e.target).hasClass("react-grid-Cell row-selected"))
		{
			let cellContainer = $(this.componentLabel).parent().parent().parent();
			if(cellContainer.length>0)
			{
				cellContainer = cellContainer[0];
				if(cellContainer == e.target)
				{
					if($(this.inputField).is(":checked"))
					{
						$(this.inputField).iCheck("uncheck");
					}
					else 
					{
						$(this.inputField).iCheck("check");
					}
				}
			}
		}
	}

	onMouseDown()
	{
		$(this.inputField).focus();
	}

	render()
	{
		let _allowEdit = true;let _display = "none";let _style = {textAlign:'center',margin:'0px'};

		if(!this.props.isSelectedRecords)
		{
			let _key = FormItemUtil.getFormItemControlKey(this.props.menuItemId,this.props.formId,this.props.colXml.id);
			let control = FormItemUtil.getFormItemControl(_key,this.props.forLookup);
			_allowEdit = control.getProperty_AllowEdit_Final(this.props.rowData,this.props.group.afterRecordConditionTask);
			if(this.props.forLookup)
				_display = "none";
			else
			{
				// if(this.props.rowData && this.props.group)
				// {
				// 	let dsAlias = this.props.group.groupAlias;
				// 	let recVerKey = dsAlias+'.recVersion';
				// 	let recVer = this.props.rowData[recVerKey];
				// 	if(recVer && typeof(recVer) == "number")
				// 	{
				// 		if(recVer > -1)
				// 			_display = "none";
				// 	}
				// }
				// if(!_display)
					_display = this.props.group==undefined ? "none":(this.props.group
						.isCurrentDataFieldModified(this.props.rowData,this.props.dataField)?"block":"none");
			}
			if(_display == "block")_style.backgroundColor = "#f8e8b7";
			
			let clientStyle = CommonUtil.getClientLayerRowStyles(window.formModuleInstance,null,"getDataGridStyle_"+this.props.gridXml.name,[this.props.rowData,this.props.dataField]);
		
			if(clientStyle)
			{
				_style = Object.assign(_style,clientStyle);
			}

			let rowStyles = this.getRowStyles();
			
			if(rowStyles)
			{
				for(let i = 0;i<rowStyles.length;i++)
				{
					let rowStyle = rowStyles[i];
					let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,rowStyle.recordCondition);
					if(bool)
					{
						if(rowStyle.color != -1)
							_style.color = "#"+StringUtil.toColorStyleString(rowStyle.color);//rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
						if(rowStyle.backgroundColor != -1)
							_style.backgroundColor = "#"+StringUtil.toColorStyleString(rowStyle.backgroundColor);//rowStyle.backgroundColor.toString(16);
						if(rowStyle.fontSize != -1)
							_style.fontSize = rowStyle.fontSize;
						if(rowStyle.fontFamily != null)
							_style.fontFamily = rowStyle.fontFamily;
						if(rowStyle.fontWeight != null)
							_style.fontWeight = rowStyle.fontWeight;
					}
				}
			}

			let colStyles = this.getEditorStyles();
			if(colStyles)
			{
				for(let i = 0;i<colStyles.length;i++)
				{
					let colStyle = colStyles[i];
					let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,colStyle.recordCondition);
					if(bool)
					{
						if(colStyle.color != -1)
							_style.color = "#"+StringUtil.toColorStyleString(colStyle.color);//colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
						if(colStyle.backgroundColor != -1)
							_style.backgroundColor = "#"+StringUtil.toColorStyleString(colStyle.backgroundColor);//colStyle.backgroundColor.toString(16);
						if(colStyle.fontSize != -1)
							_style.fontSize = colStyle.fontSize;
						if(colStyle.fontFamily != null)
							_style.fontFamily = colStyle.fontFamily;
						if(colStyle.fontWeight != null)
							_style.fontWeight = colStyle.fontWeight;
					}
				}
			}
		}
		let _clsName = "dataGridrender gongqi_render_select gongqi_render_boolean gongqi_render_"+this.props.colXml.name;
		if(_style.backgroundColor)_clsName+=" gongqi_render_back";
		if(_display == "block")_clsName+=" gongqi_render_version0";
		/*Q21096256this.renderAllowEdit = _allowEdit;
		if(this.clickOnDisable == true)
		{
			this.clickOnDisable = false;
			
			if(this.renderAllowEdit == true)
			{
				this.disableToAllowEdit = true;
			}
		}*/
		
		if(_allowEdit)
		{
			return(
				<div className={_clsName} style={_style} ref={ node => this.componentLabel = node } onMouseDown={this.onMouseDown.bind(this)} render='true'>
	              
	                <input type="checkbox" ref={node=>this.inputField=node}  className="minimal"/>
	            
	              <i ref={node => this.modifiedTag = node} className="fa fa-sort-desc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-3px",right:"0px",transform:'rotate(224deg) scale(1.5)',zIndex:"100",display:_display}}></i>
	            </div>
			);
		}
		else
		{
			return(
				<div className={_clsName+" disabled"} style={_style} ref={ node => this.componentLabel = node } 
					onMouseDown={this.onMouseDown.bind(this)}	onClick={this.checkboxDiveClick.bind(this)} render='true'>
	            
	                <input type="checkbox" disabled ref={node=>this.inputField=node} className="minimal"/>
	             
	              <i ref={node => this.modifiedTag = node} className="fa fa-sort-desc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-3px",right:"0px",transform:'rotate(224deg) scale(1.5)',zIndex:"100",display:_display}}></i>
	            </div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemBooleanRender.js